<template>
    <div :id="ID_COMPONENTE" class="container-fluid pb-0">
        <div class="row">
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Micrositio&nbsp;&nbsp;                   
                </h6>
                <C001PaginaInicio   v-on:valorParaElPadre="cambioTipoDePagina" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaPasoUno'" :parametros="{3: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" :valorDefinido="tipoDePaginaWebId"></C001PaginaInicio>              
            </div>
            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Posición donde se muestra&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.POSICION.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']" 
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.POSICION.llave)"></i>
                </h6>
            <select @change="cambiarDatos($event)" class="form-control" >
                 <option value="-1" >Seleccione tipo de menú</option>
                <option value="1">Menú Principal</option>        
                 <option value="2">Sitio De Interes</option>
            </select> 
            </div>

            <div class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-2 pt-1">
                <h6>Menú al que pertece&nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.MENU.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.MENU.llave)"></i>
                </h6>
                <C004Menus  
                    :class="[false ? 'border border-danger p-0 m-0': 'p-0 m-0']" 
                    v-on:valorParaElPadre="evtCambioMenu" 
                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                    :idDelInput="filtrosBusqueda.catalogoMenus.ID" 
                    :parametros="filtrosBusqueda.catalogoMenus.parametros" 
                    :valorDefinido="filtrosBusqueda.catalogoMenus.valorDefinido" 
                    :key="filtrosBusqueda.catalogoMenus.KEY + ID_COMPONENTE + filtrosBusqueda.catalogoMenus.contRender"></C004Menus>
            </div>

   <fieldset class="scheduler-border  col-xs-12 col-sm-12 col-md-4 col-lg-4 pr-2 pt-1 no-gutters">
                            <legend class="legend-scheduler-border">Submenús&nbsp;&nbsp;
                            </legend>
           <div v-if="tieneOtrosSubmenus"   class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                <h6>Menú al que pertece &nbsp;&nbsp;
                    <i :class="[(filtrosBusqueda.activos.MENU.activo) ? 'fas fa-check-square check-activacion-filtros' : 'far fa-square check-activacion-filtros']"
                        @click="evtActivacionFiltro(filtrosBusqueda.activos.MENU.llave)"></i>
                </h6>
                <SelectRecursivo  v-on:valorParaElPadre="evtCambioSubmenu" :Submenus="subMenusMicrositio" :SoloConSubmenus="true" :key="keySubmenu" ></SelectRecursivo>
            </div>
    </fieldset>&nbsp;&nbsp;&nbsp;&nbsp;

       <fieldset class="scheduler-border  col-xs-12 col-sm-12 col-md-7 col-lg-7 pr-2 pt-1 no-gutters" style="height:8em">
                            <legend class="legend-scheduler-border">Otras Opciones&nbsp;&nbsp;
                            </legend>
           <div class="contenedor-opciones">
               &nbsp;&nbsp;&nbsp;&nbsp;<label class="opcion">Es Descarga</label>&nbsp;&nbsp;&nbsp;&nbsp;
               <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[conDescarga?'active':'' ]" @click="conDescarga=true">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Si
                        </label>
                        <label class="btn btn-secondary" :class="[!conDescarga?'active':'' ]"  @click="conDescarga=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No
                        </label>
               </div>
                 &nbsp;&nbsp;&nbsp;&nbsp;<label class="opcion">Solo Activos</label>&nbsp;&nbsp;&nbsp;&nbsp;

               <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[soloActivos?'active':'' ]" @click="soloActivos=true;soloCancelados=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Si
                        </label>
                        <label class="btn btn-secondary" :class="[!soloActivos?'active':'' ]"  @click="soloActivos=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No
                        </label>
               </div>
                 &nbsp;&nbsp;&nbsp;&nbsp;<label class="opcion">Solo Cancelados</label>&nbsp;&nbsp;&nbsp;&nbsp;

               <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[soloCancelados?'active':'' ]" @click="soloCancelados=true;soloActivos=false">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Si
                        </label>
                        <label class="btn btn-secondary" :class="[!soloCancelados?'active':'' ]"  @click="soloCancelados=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No
                        </label>
               </div>

               &nbsp;&nbsp;&nbsp;&nbsp;<label class="opcion">Se Muestra en Visor</label>&nbsp;&nbsp;&nbsp;&nbsp;

               <div class="btn-group btn-group-toggle linea-horizontal" data-toggle="buttons">
                        <label class="btn btn-secondary" :class="[soloSeMuestraEnVisor?'active':'' ]" @click="soloSeMuestraEnVisor=true">
                            <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Si
                        </label>
                        <label class="btn btn-secondary" :class="[!soloSeMuestraEnVisor?'active':'' ]"  @click="soloSeMuestraEnVisor=false">
                            <input type="radio" name="options" id="esVisualizado" autocomplete="off" >No
                        </label>
               </div>

               
                           </div>
    </fieldset>


            
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-2 pt-1">
                <div class="d-flex justify-content-end">
                    <button  type="button" @click="evtRealizarBusqueda" class="btn btn-primary ml-2"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import catalogos from '@/../static/js/catalogos'
import enumeraciones from '@/../static/js/enumeraciones'
 import C001PaginaInicio from '@/components/SICPO/Catalogos/C001PaginaInicio.vue'
 import SelectRecursivo from '@/components/SICPO/Micrositios/Menu/SelectRecursivoMicrositio.vue'
 import comun from '@/../static/js/comun'
export default {
     props: {
        ID_COMPONENTE: {
            type: String,
            default: 'filtrosDeBusqueda-menus-pw'
        },
        esParaPagina: {
            type: Object,
            default: () => ({ tipoPagina: 1 })
        },
    },
    components: {
        C005TiposPosicion: catalogos.SICPO.C005TiposPosicion,
        C004Menus: catalogos.SICPO.C004Menus,
        C001PaginaInicio,
        SelectRecursivo
    },
    data() {
        return {
            idDePosicion:-1,
            paginaId:-1,
            soloSeMuestraEnVisor:false,
            soloCancelados:false,
            soloActivos:false,
            conDescarga:false,
            subMenusMicrositio:[],
            tieneOtrosSubmenus:false,
            conSubmenuQueMePertenece:false,
            historialIdSUbmenu:[],
          
            enumeraciones,
            PAGINA_OFICIAL_ID: 1,
            tipoDePaginaWebId: -1,
             filtrosBusqueda: {
                titulo: null,
                esDescarga: false,
                seMuestraEnVisor: false,
                catalogoPaginasDeInicio: {
                    ID: 'CPaginaInicio',
                    REF: 'REFPaginaInicio',
                    parametros: { PaginaDeInicioId: null, TipoPaginaId: 1, PaginaWebId: null, PaginaMicrositioId: null, MenuId: null, ConInactivas: false, ConMenus: false, ConPaginasWeb: false, ConPaginasMicrositios: false },
                    valorDefinido: -1,
                    paginaSeleccionada: null,
                    KEY: 'KPaginaInicio',
                    contRender: 0
                },
                catalogoMenus: {
                    ID: 'CMenus',
                    REF: 'REFMenus',
                    parametros: { MenuId: null, SubmenuId: null, TipoPosicionId: null, PaginaWebId: null, PaginaDeInicioId: null, ConInactivos: false, ConSubmenus: true, ConTodosLosSubmenus: true, ConTodasLasPaginasWebDelSubmenu: false, ConPaginasWeb: false, ConPaginasDeInicio: false, ConOrdenamientoDelMenu: false, ConOrdenamientoDelSubmenu: false },
                    valorDefinido: -1,
                    menuSeleccionado: null,
                    KEY: 'KMenus',
                    contRender: 0
                },
                catalogoSubmenu: {
                    ID: 'CSubMenus',
                    REF: 'REFSubMenus',
                    parametros: { SubmenuId: null, MenuId: null, PaginaWebId:null, SubmenuIdDelQuePertenezco:null, SubmenuIdQueMePertenece:null, ConInactivos:false, ConMenu:false, ConMenusLosSubmenus:false, ConSubmenusQueMePertenecen:true, ConTodosLosSubmenusQueMePertenecen: true, ConTodasLasPaginasWebDelSubmenu:false, ConSubmenuDelQueDesciende:true, ConPaginasWeb:false, ConOrdenamiento:false, ConOrdenamientoDeLosSubmenus:false, SoloPermiteSubirContenido:false },
                    valorDefinido: -1,
                    subMenuSeleccionado: null,
                    KEY: 'KSubMenus',
                    contRender: 0,
                    hijos: {
                        KEY: 'KSubMenuHijo',
                        contRender: 0,
                        seleccionado: null,
                        historialDeSeleccion: []
                    }
                },
                activos: {
                    PAGINA_INICIO: { activo: true, llave: 1 },
                    MENU: { activo: true, lave: 2 }, 
                    TITULO_SUBMENU:{ activo: true, llave: 3 },
                    ACCESO: { activo: true, llave: 4 },
                    HERENCIA_SUBMENU: { activo: true, llave: 5 },
                    POSICION: { activo: true, lave: 2 }, 
                }
            },



        }
    },
    methods: {
        evtCambioMenu: function(evento, menuObj) {
               this.filtrosBusqueda.catalogoMenus.valorDefinido = parseInt(evento.target.value);
              if(menuObj!=undefined && menuObj != null){
            this.submenusMicrositio = menuObj.Submenus;
            this.keySubmenu= this.keySubmenu+1;
             this.tieneOtrosSubmenus = true;
              this.subMenusMicrositio =menuObj.Submenus
              }
           // se actualiza catalogo de submenus
            this.filtrosBusqueda.catalogoSubmenu.parametros.MenuId = this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoMenus.valorDefinido) ? this.filtrosBusqueda.catalogoMenus.valorDefinido : null;
          //  this.filtrosBusqueda.catalogoSubmenu.valorDefinido = -1;        
          //  this.filtrosBusqueda.catalogoSubmenu.contRender ++;
            this.filtrosBusqueda.catalogoSubmenu.subMenuSeleccionado = null;

            // se limpia el valor del submenu hijo en caso de que tenga uno asignado
            this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = null; 
            this.filtrosBusqueda.catalogoSubmenu.hijos.historialDeSeleccion = [];
            this.conSubmenuQueMePertenece=false;
        },
         evtCambioSubmenu: function(evento,menuObj,menuAnterior) {         
            var respuesta =(menuObj!=undefined)? this.validaSubmenus(menuObj.SubmenusQueMePertenecen):undefined;
          // this.filtrosBusqueda.catalogoMenus.valorDefinido = parseInt(evento.target.value);
            if(evento.target.value != -1 && respuesta!= undefined){

                 this.validaSubmenus(menuObj.SubmenusQueMePertenecen)
                this.conSubmenuQueMePertenece=true;
                this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado = menuObj.SubmenuId;
                 this.historialIdSUbmenu.splice(this.historialIdSUbmenu.indexOf(parseInt(menuAnterior)),this.historialIdSUbmenu.length)   

                if(!this.historialIdSUbmenu.includes(menuObj.SubmenuId))
                 this.historialIdSUbmenu.push(menuObj.SubmenuId);
                  
                //  console.log("menuAnteriorr ::: :: ::",menuAnterior)

                // console.log("no es -1 ::: :: ::",this.historialIdSUbmenu)
        
            }else{
               this.historialIdSUbmenu.splice(this.historialIdSUbmenu.indexOf(parseInt(menuAnterior)),this.historialIdSUbmenu.length)          
               var ultimoElemento= this.historialIdSUbmenu[this.historialIdSUbmenu.length -1]
               if(ultimoElemento == undefined) this.conSubmenuQueMePertenece=false;
               else   this.conSubmenuQueMePertenece=true;

                this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado =ultimoElemento;
                
            }
//console.log("HISTORIALLL ::: :: ::",this.historialIdSUbmenu)
        },
        validaSubmenus:function(submenus){
            let submenusConSubmenus=[]
            for(var i =0;i<submenus.length;i++){
                if((submenus[i].SubmenusQueMePertenecen.length>0)){
                this.tieneOtrosSubmenus = true;
                submenusConSubmenus.push(submenus[i]);
                }
              

            }
            submenusConSubmenus = submenus;
return submenusConSubmenus;
           // this.subMenusMicrositio = submenus
            // if(this.tieneOtrosSubmenus) this.keySubmenu=1;

        },
        cambiarDatos(evento){   
        this.idDePosicion = evento.target.value;
        this.filtrosBusqueda.catalogoMenus.TipoPosicionId = evento.target.value;
         this.filtrosBusqueda.catalogoMenus.valorDefinido = parseInt(evento.target.value);
            this.filtrosBusqueda.catalogoMenus.parametros.TipoPosicionId = this.idDePosicion;
            this.filtrosBusqueda.catalogoMenus.contRender = this.idDePosicion ;
            
             
          //    let menuObjSeleccionado = this.menus.find(m => m.MenuId == evento.target.value);
        //this.$emit("valorParaElPadre",evento,menuObjSeleccionado);

      },
        cambioTipoDePagina: function (evento) {
            this.paginaId=evento.target.value;
            this.filtrosBusqueda.catalogoMenus.parametros.PaginaDeInicioId = this.paginaId;
            this.filtrosBusqueda.catalogoMenus.contRender = this.paginaId ;

        },
        evtRealizarBusqueda: function() {
            const FILTROS = {
                paginaId: this.paginaId,
                posicionId:  this.idDePosicion,
                menuId:this.filtrosBusqueda.catalogoMenus.valorDefinido,
                conSubmenuQueMePertenece:this.conSubmenuQueMePertenece,
                submenuId: this.filtrosBusqueda.catalogoSubmenu.hijos.seleccionado,
                soloSeMuestraEnVisor:this.soloSeMuestraEnVisor,
                soloCancelados:this.soloCancelados,
                soloActivos:this.soloActivos,
                conDescarga:this.conDescarga
                

            }
          //  console.log("FILTROS",FILTROS)
             if(this.paginaId== -1)comun.mensajeDeAlerta("Elija un Micrositio", null, null);
             else if(this.idDePosicion==-1)  comun.mensajeDeAlerta("Elija una Posición", null, null);
             else if(this.filtrosBusqueda.catalogoMenus.valorDefinido== -1)comun.mensajeDeAlerta("Elija un Menu", null, null);
             else this.$emit('RealizarBusquedaDeMenus', FILTROS);
       
        },
        evtLimpiarFiltros: function() {
            // catalogos
            this.filtrosBusqueda.catalogoPaginasDeInicio.parametros.TipoPaginaId = this.esParaPagina.tipoPagina;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = this.PAGINA_OFICIAL_ID;
            this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido = -1;
            // caracteristicas
            this.filtrosBusqueda.titulo = null;
            this.filtrosBusqueda.esDescarga = false;
            this.filtrosBusqueda.esMenuEspecial = false;
            this.filtrosBusqueda.menuParpadea = false;
            // se renderizan los catalogos
            this.filtrosBusqueda.catalogoPaginasDeInicio.contRender ++;
            this.filtrosBusqueda.catalogoTiposPosiciones.contRender ++;
        },
        evtCambioPaginaInicio: function(evento) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioPosicion: function(evento) {
            this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido = parseInt(evento.target.value);
        },
        evtActivacionFiltro: function(tipoDeFiltro) { 
            const ESTADO_DE_FILTROS = Object.values(this.filtrosBusqueda.activos);
            let filtro = ESTADO_DE_FILTROS.find(fb => fb.llave == tipoDeFiltro);
            if(this.campoRequeridoEsValido(filtro)) {
                filtro.activo = !filtro.activo;
            }
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    computed: {
        habilitarBusqueda() {
            return (this.campoRequeridoEsValido(this.filtrosBusqueda.catalogoTiposPosiciones.valorDefinido) && this.filtrosBusqueda.activos.POSICION.activo);
        }
    },
    created() {
        if(this.esParaPagina.tipoPagina == this.PAGINA_OFICIAL_ID) {
            this.filtrosBusqueda.catalogoPaginasDeInicio.parametros.TipoPaginaId = this.esParaPagina.tipoPagina;
            this.filtrosBusqueda.catalogoPaginasDeInicio.valorDefinido = this.PAGINA_OFICIAL_ID;
            this.esParaPaginaWeb = true;
            this.$nextTick(() => {
                // se actualiza catalogo de menus
                this.filtrosBusqueda.catalogoPaginasDeInicio.contRender ++;
            });
        }
    },
}
</script>
<style scoped>
.opcion{
    font-size: 1.5em;
}
.contenedor-opciones{
    display:flex;
    justify-content: center;
    align-items: center;
}
#scheduler-border {
    border: 1px groove #ddd !important;
    padding: 0 1.4em 1.4em 1.4em !important;
    margin: 0 0 1.5em 0 !important;
    -webkit-box-shadow:  0px 0px 0px 0px #000;
            box-shadow:  0px 0px 0px 0px #000;
}

#legend-scheduler-border {
    font-size: 1.2em !important;
    font-weight: bold !important;
    text-align: left !important;
    width:auto;
    padding:0 10px;
    border-bottom:none;
}


.scheduler-border {
    border: 1px groove #ddd !important;
    padding: 0 1.4em 1.4em 1.4em !important;
    margin: 0 0 1.5em 0 !important;
    -webkit-box-shadow:  0px 0px 0px 0px #000;
            box-shadow:  0px 0px 0px 0px #000;
}

.legend-scheduler-border {
    font-size: 1.2em !important;
    font-weight: bold !important;
    text-align: left !important;
    width:auto;
    padding:0 10px;
    border-bottom:none;
}

.deshabilitarSeccionCatalogos {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.check-activacion-filtros {
    cursor: pointer;
}

.btn-secondary:not(:disabled):not(.disabled).active, 
.btn-secondary:not(:disabled):not(.disabled):active, .show > #opciones-toggle .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Menu/CFiltrosDeBusquedaSubMenusMicrositio.vue